<template>
  <a-modal
    title="新建/编辑"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
  >
    <a-form :form="form">
      <a-form-item style="display:none">
        <a-input v-decorator="['matterCode']"/>
      </a-form-item>
      <!--<a-form-item style="display:none">-->
        <!--<a-input v-decorator="['id']"/>-->
      <!--</a-form-item>-->
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="待办事项名称">
        <a-input v-decorator="['matterName',{ rules: [{ required: true, message: '请输入待办事项名称' }] }]" disabled/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="待办事项类型">
        <a-input v-decorator="['matterTypeName',{ rules: [{ required: true, message: '请输入待办事项类型' }] }]" disabled/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="一级接收人">
        <a-select
          v-decorator="['firstReceiveList',{ rules: [{ required: true, message: '请选择一级接收人' }] }]"
          mode="multiple"
          @change="handleChange"
        >
          <a-select-option  v-for="type in recipient" :key="type.code"> {{type.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="二级接收人">
        <a-select
          v-decorator="['secondReceiveList']"
          mode="multiple"
          @change="handleChange"
        >
          <a-select-option  v-for="type in recipient" :key="type.code"> {{type.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="一级抄送人">
        <a-select
          v-decorator="['firstCopyToList']"
          mode="multiple"
          @change="handleChange"
        >
          <a-select-option  v-for="type in recipient" :key="type.code"> {{type.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="二级抄送人">
        <a-select
          v-decorator="['secondCopyToList']"
          mode="multiple"
          @change="handleChange"
        >
          <a-select-option  v-for="type in recipient" :key="type.code"> {{type.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-row>
        <a-col :span="16" :offset="2">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="超时时间">
            <!--<a-input  v-decorator="['timeoutPeriod']" style="200px"/>-->
            <a-input v-model="textTime1" @keyup.native="number1"/>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-model="selectTime1"  style="width: 130px;margin: 0px 16px 0px -47px;" @change="timeChange1">
              <a-select-option value=""> 选择 </a-select-option>
              <a-select-option value="D"> 天 </a-select-option>
              <a-select-option value="H"> 小时 </a-select-option>
              <a-select-option value="M"> 分钟 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="16" :offset="2">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="超时结束时间">
            <!--<a-input v-decorator="['timeoutEndTime']"/>-->
            <a-input v-model="textTime2" @keyup.native="number2"/>
          </a-form-item>
        </a-col>
        <a-col :span="4" >
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-model="selectTime2"  style="width: 130px;margin: 0px 16px 0px -47px;" @change="timeChange2">
              <a-select-option value=""> 选择 </a-select-option>
              <a-select-option value="D"> 天 </a-select-option>
              <a-select-option value="H"> 小时 </a-select-option>
              <a-select-option value="M"> 分钟 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理跳转页面">
        <a-select v-decorator="['jumpUrl',{ rules: [{ required: true, message: '请选择产品类别' }] }]">
          <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发起人">
        <a-select
          v-decorator="['initiatorCodes']"
          mode="multiple"
          @change="handleChange"
        >
          <a-select-option  v-for="type in initiator" :key="type.roleKey"> {{type.roleName}}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

  import { getPendingMattersRoleList,pendingMatterInfo,update,roleList } from '@/api/basicdatas/Backlog'
  import pick from 'lodash.pick'
  import { getDictMap } from "../../../utils/dict"

  export default {
    name: "BacklogModal",
    components: {
    },
    data () {
      return {
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        restaurantTypes:[], // 跳转页面
        restaurantOperTypeMap:[],
        recipient:[], // 抄送人
        initiator:[], // 发起人
        textTime1:'',
        selectTime1:'',
        textTime2:'',
        selectTime2:'',
        istrue1:0,
        istrue2:0,
      }
    },
    beforeCreate () {
    },
    async created () {
      // 跳转页面
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('jump_page_code');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
      // console.log(this.restaurantTypes)
      // 接收人，抄送人
      getPendingMattersRoleList().then(res=>{
        this.recipient = res.data
        // console.log(this.recipient)
      })
      // 发起人下拉
      roleList().then(res=>{
        // console.log(res)
        this.initiator = res.rows
        // console.log(this.initiator)
      })
    },
    methods: {
      number1(){
        this.textTime1 = this.textTime1.replace(/[^\.\d]/g,'');
        this.textTime1 = this.textTime1.replace('.','');
      },
      number2(){
        this.textTime2 = this.textTime2.replace(/[^\.\d]/g,'');
        this.textTime2 = this.textTime2.replace('.','');
      },
      edit(record) {
        // 待办事项详情
        // console.log("record",record)
        var that=this
        pendingMatterInfo({matterCode:record.matterCode}).then(res=>{
          // console.log('详情',res.data)
          let time = res.data.timeoutPeriod
          if(time == null){
            that.textTime1 = ''
            that.selectTime1 = ''
          }else{
            that.textTime1 = time.substr(0, time.length-1);
            that.selectTime1 = time.substr(time.length-1,1)
          }
          let time1 = res.data.timeoutEndTime
          if(time1 == null){
            that.textTime2 = ''
            that.selectTime2 = ''
          }else{
            that.textTime2 = time1.substr(0, time1.length-1);
            that.selectTime2 = time1.substr(time1.length-1,1)
          }
          that.mdl = res.data
          that.$nextTick(() => {
            that.form.setFieldsValue(pick(that.mdl, 'id', 'matterCode', 'matterName', 'matterTypeName', 'firstReceiveList', 'secondReceiveList', 'firstCopyToList' , 'secondCopyToList', 'timeoutPeriod', 'timeoutEndTime', 'jumpUrl', 'initiatorCodes'))
          })
        })
        // this.mdl = Object.assign(record)
        this.visible = true
      },
      timeChange1(value){
        // console.log(value)
        this.selectTime1 = value
      },
      timeChange2(value){
        // console.log(value)
        this.selectTime2 = value
      },
      handeStimate(value1,value2,){
        if(value1 != "" && value2 != ""){
          return 1
        }else if(value1 == "" && value2 == ""){
          return 1
        }else{
          this.$message.error('请把时间填写完整!')
          return 0
        }
      },
      handleSubmit(e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            // console.log('Received values of form: ', values)
            // if(this.textTime1 != "" && this.selectTime1 != ""){
            //   this.isTrue1 = 1
            // }else if(this.textTime1 == "" && this.selectTime1 == ""){
            //   this.isTrue1 = 1
            // }else{
            //   this.$message.error('请把超时时间填写完整!')
            // }
            //
            // if(this.textTime2 != "" && this.selectTime2 != ""){
            //   this.isTrue2 = 1
            // }else if(this.selectTime2 == "" && this.selectTime2 == ""){
            //   this.isTrue2 = 1
            // }else{
            //   this.$message.error('请把超时结束时间填写完整!')
            // }
            this.istrue1 = this.handeStimate(this.textTime1,this.selectTime1)
            this.istrue2 = this.handeStimate(this.textTime2,this.selectTime2)
            // console.log(this.istrue1,this.istrue2)
            delete values.matterName
            delete values.matterTypeName
            values.timeoutPeriod = this.textTime1 + this.selectTime1
            values.timeoutEndTime = this.textTime2 + this.selectTime2
            // console.log(this.isTrue1,this.isTrue2)
            if(this.istrue1== 1 && this.istrue2 == 1){
              this.confirmLoading = true
              update(values).then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok')
                  this.isTrue1 = 0
                  this.isTrue2 = 0
                  // console.log(this.isTrue1,this.isTrue2)
                  this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>